'use client';
import React from 'react';
import Div from '@pezeshk-book/ui-kit/div';
import Media from '@pezeshk-book/ui-kit/media';
import { TopSellerSliderProps } from './top-seller-slider.props';
import SliderItem from './slider-item';
import { Slider } from '@pezeshk-book/modules';

const TopSellerSlider = ({ data, callbackFunction, mobileDifference, translate, buttonTitle }: TopSellerSliderProps) => {
  let children = [];
  if (process.env.LABORATORY_SERVICE_ACTIVE === 'true' || process.env.CONSULT_SERVICE_ACTIVE === 'true' || process.env.HOME_CARE_SERVICE_ACTIVE === 'true') {
    children = data?.map((item, index) => {
      if (item?.isActive) {
        return (
          <SliderItem
            type={item.type}
            unit={item.unit}
            callbackFunction={callbackFunction}
            key={`PharmacyTopSell${index}`}
            title={translate[item.translateIndex].title}
            subTitle={translate[item.translateIndex].description}
            image={item.image}
            route={item.route}
            buttonTitle={buttonTitle}
          />
        );
      }
      return null;
    });

    if (mobileDifference) {
      return (
        <Div className={'w-full'}>
          <Slider
            slides={3}
            tabletSlides={2}
            mobileSlides={1}
            spaceBetween={35}
            infiniteLoop={true}
          >
            {children}
          </Slider>
        </Div>
      );
    }

    return (
      <Div className={'w-full'}>
        <Media greaterThan={'sm'}>
          <Div className={'w-full justify-center'}>
            {children}
          </Div>
        </Media>
        <Media lessThan={'md'} className={'w-full'}>
          <Slider
            spaceBetween={35}
            slides={3}
            tabletSlides={1}
            mobileSlides={1}
            infiniteLoop={true}
          >
            {children}
          </Slider>
        </Media>

      </Div>
    );
  }

  return null;
};

export default TopSellerSlider;
